/**
 * Created by Cemali Gencer on 16.1.2017.
 */
var ws_thumbs = $('#wowslider-container1 .ws_thumbs > div > a');
if(ws_thumbs.length <= 4)
{
    $('#wowslider-container1 .ws_thumbs > div').addClass('fix_pos');
}